import React, { Component } from 'react';
import I18n, { translationListToSelectOptions } from '~/utils/translations';
import Select from '~/components/shared/select';

export default class UserTypeInput extends Component {
  render() {
    return (
      <Select
        label={I18n.t('login_or_signup.labels.broker')}
        name="user_type"
        className="about-you__broker"
        options={this.renderBrokerOptions()}
        value={this.props.user_type}
        onChange={this.props.onChange}
        isSearchable={false}
        placeholder={I18n.t('login_or_signup.options.broker_placeholder')}
      />
    );
  }

  renderBrokerOptions = () => {
    return translationListToSelectOptions(I18n.t('login_or_signup.options.user_type'));
  };
}
